import { useLocation, useNavigate } from 'react-router-dom';
import articleLanguagePaths from '@/components/en/articleLanguagePaths';

/**
 * Two-way language switcher for the English (/en/...) section.
 * Maps each English slug to its Danish counterpart and vice-versa.
 */

// English slug -> Danish path
export const EN_TO_DA = {
  '/en': '/',
  '/en/ny-checkout': '/ny-checkout',
  '/en/electricity-deal': '/elaftale',
  '/en/chargers': '/opladere',
  '/en/compare-electricity-companies': '/elpris-sammenligning',
  '/en/smart-charge-price-guarantee': '/portal/smart-charge',
  '/en/electricity-benefits': '/el-fordele',
  '/en/electricity-price-hour-by-hour': '/pris-time-for-time',
  '/en/welcome': '/velkommen',
  '/en/solar-agreement': '/solcelleaftale',
  '/en/support': '/supportkundeportal',
  '/en/customer-portal': '/kundeportal',
  '/en/supported-car-brands': '/understoettede-bilmaerker',
  '/en/blog': '/blog',
  '/en/app-guide': '/enkel-app',
  '/en/service-agreement': '/service-aftale',
  '/about-en': '/about',
  ...articleLanguagePaths,
};

// Danish path -> English slug
export const DA_TO_EN = Object.fromEntries(
  Object.entries(EN_TO_DA).map(([en, da]) => [da, en])
);
DA_TO_EN['/smart-charge-prisgaranti'] = '/en/smart-charge-price-guarantee';
DA_TO_EN['/selvbetjening'] = '/en/support';
DA_TO_EN['/kontakt'] = '/en/support';
DA_TO_EN['/faq'] = '/en/support';
DA_TO_EN['/new-faq'] = '/en/support';
DA_TO_EN['/el'] = '/en/electricity-deal';
DA_TO_EN['/elaftale-b'] = '/en/electricity-deal';
DA_TO_EN['/smart-charge'] = '/en/smart-charge-price-guarantee';
DA_TO_EN['/laderabat'] = '/en/electricity-benefits';
DA_TO_EN['/zaptec-go'] = '/en/chargers';
DA_TO_EN['/zaptec-go-2'] = '/en/chargers';
DA_TO_EN['/nexblue-edge-2'] = '/en/chargers';

export default function EnLangSwitch({ className = '', dark = false }) {
  const location = useLocation();
  const navigate = useNavigate();

  const currentPath = location.pathname.replace(/\/$/, '').toLowerCase() || '/';
  const daTarget = EN_TO_DA[currentPath] || '/';

  const base = dark
    ? 'border-white/15 text-white/80 hover:text-white hover:border-white/40'
    : 'border-[#263A43]/15 text-[#21343D] hover:border-[#5E7B8C]/40 hover:bg-[#F1EBDD]';

  return (
    <div className={`inline-flex items-center rounded-full border overflow-hidden text-xs font-semibold ${base} ${className}`}>
      <span className="px-2.5 py-1.5 bg-[#D4A62A]/15 text-[#7A5A08]">EN</span>
      <button
        onClick={() => { try { localStorage.setItem('enkel_lang_pref', 'da'); } catch {} navigate(daTarget + window.location.search + (location.hash === '#plans' ? '#aftaler' : location.hash)); }}
        className="px-2.5 py-1.5 hover:opacity-80 transition-opacity"
        aria-label="Skift til dansk"
      >
        DA
      </button>
    </div>
  );
}